export const state = () => {
	return {
		nbClaimsToSend: 0,
		nbClaimsToSendGifting: 0,
	}
}

export const actions = {
	async getNbClaimsToSend({ commit }, { companyId }) {
		return await useNuxtApp()
			.$api(`api/company/${companyId}/claims/`, {
				params: {
					status: 'VAL',
					limit: 1,
					distrib_mode: 'DIR',
					promo_type: 'BAD,PRO,PER,PRO,SHI,BON,BXGY,BXGYP,CUS',
				},
			})
			.then((res) => {
				commit('setNbClaimsToSend', res.count)
				return res.count
			})
	},

	async getNbClaimsToSendGifting({ commit }, { companyId, campaignId }) {
		return await useNuxtApp()
			.$api(`api/company/${companyId}/claims/`, {
				params: {
					status: 'VAL',
					limit: 1,
					distrib_mode: 'DIR',
					promo_type: 'GIF',
					campaign_id: campaignId,
				},
			})
			.then((res) => {
				commit('setNbClaimsToSendGifting', res.count)
				return res.count
			})
	},

	async list(_, { companyId, params }) {
		const paramsClone = { ...params }
		for (const key in paramsClone) {
			if (Array.isArray(paramsClone[key])) {
				paramsClone[key] = paramsClone[key].join(',')
			}
		}

		return await useNuxtApp().$api(`api/company/${companyId}/claims/`, { params: paramsClone })
	},

	async next(_, { pageURL }) {
		return await useNuxtApp()
			.$api(pageURL)
			.then((res) => {
				return res
			})
	},

	async exportCSV(_, { params, companyId }) {
		return await useNuxtApp().$api(`/api/company/${companyId}/claims/export/`, {
			method: 'POST',
			body: {
				filter_data: params,
			},
		})
	},

	async partialUpdate(_, { companyId, claimId, data }) {
		return await useNuxtApp().$api(`/api/company/${companyId}/claims/${claimId}/`, {
			method: 'PATCH',
			body: data,
		})
	},

	async massCreate(_, { companyId, data }) {
		return await useNuxtApp()
			.$api(`/api/company/${companyId}/claims/mass-create/`, {
				method: 'POST',
				body: data,
			})
			.then((res) => res.creator_ids_claim)
	},

	async massUpdate(_, { companyId, params }) {
		return await useNuxtApp().$api(`/api/company/${companyId}/claims/mass-update/`, {
			method: 'PATCH',
			body: params,
		})
	},

	async count(_, { companyId, params }) {
		let countUrl = `api/company/${companyId}/challenges/?limit=1`

		const { status, ...restParams } = params
		if (status) status.forEach((tc) => (countUrl += `&status[]=${tc}`))

		return await useNuxtApp()
			.$api(countUrl, { params: restParams })
			.then((res) => {
				return res.count
			})
	},
}

export const mutations = {
	setNbClaimsToSend(state, data) {
		state.nbClaimsToSend = data
	},

	setNbClaimsToSendGifting(state, data) {
		state.nbClaimsToSendGifting = data
	},
}
